import * as React from "react";
import { useEffect, useState } from "react";
import { RootState } from "../../reducers/index";
import { useAppDispatch, useAppSelector } from "../../store/index";
import { setCheckoutState } from "../../reducers/checkout";
import CheckoutClientHead from "./checkoutclienthead";
import HtmlDiv from "../../components/htmldiv";

const CheckoutAgree = () => {
    const { termsHtml } = useAppSelector((state: RootState) => state.checkout);
    const dispatch = useAppDispatch();
    const [agreed, setAgreed] = useState(false);

    // If we have no terms, then immediately advance to payment state
    useEffect(() => {
        if (!termsHtml) {
            dispatch(setCheckoutState("payment"));
        }
    }, [termsHtml, dispatch]);

    const handlePayment = () => {
        dispatch(setCheckoutState("payment"));
    };

    return (
        <>
            <CheckoutClientHead />
            <h3>Program Terms &amp; Conditions</h3>
            <p>
                Please read the following and check the box &quot;I have read
                and agree to the terms above&quot;:
            </p>
            <HtmlDiv html={termsHtml} className="checkout-agree-terms" />
            <div className="my-3">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="checkAgree"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="checkAgree">
                        I have read and agree to the terms above
                    </label>
                </div>
            </div>
            <div className="mt-3">
                <button
                    className="btn btn-primary"
                    onClick={handlePayment}
                    disabled={!agreed}
                >
                    Continue to Payment
                </button>
            </div>
        </>
    );
};

export default CheckoutAgree;
